import ApiService from '~/utils/ApiService';

export const UPDATE_AGENTS = 'UPDATE_AGENTS';

export const updateAgents = (agents, teamId) => {
  return {
    type: UPDATE_AGENTS,
    agents,
    teamId,
  };
};

export const fetchAgents = team => {
  const endpoint = '/teams/' + team.id + '/agents';
  return function(dispatch) {
    return ApiService.get(endpoint).then(function(res) {
      return dispatch(updateAgents(res, team.id));
    });
  };
};
